<ag-grid-angular #gamesHistoryTableGrid *ngIf="grid" class="ag-theme-balham lato-regular w-100 overflow-auto" style="height: calc(100vh - 320px);" [gridOptions]="grid"></ag-grid-angular>

<div class="brackets-container">
    <div class="modal-container" *ngIf="isExpandedView" (click)="closeExpandedView($event)">
        <div class="modal-content" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <div class="maDetailsPopupClose close-modal show-on-load close-container btn-close"
                     (click)="closeExpandedView($event)"></div>
                <div>
                    <span class="bracket-title">{{gs.selectedGame[0].RuleName}}</span>
                    <div>
                        <span class="metric-name" cvLocalizedText langSection="Games" langKey="Metric">Metric</span>:
                        {{gs.selectedGame[0].SelectedMetrics[0].abbrev}}
                    </div>
                </div>
            </div>
            <hr class="modal-divider" />
            <cv-bracket-view [data]="gs.selectedGame[0].HistoryBracketTournamentMatches"
                             [numberOfRounds]="gs.selectedGame[0].HistoryBracketTournamentDetails.NumberOfRounds"
                             [currentUser]="currentParticipant"
                             [selectedMetrics]="gs.selectedGame[0].SelectedMetrics"
                             [assignedGroups]="gs.selectedGame[0].HistoryEligibility.AssignedGroups"
                             [rounds]="gs.selectedGame[0].HistoryBracketTournamentRounds">
            </cv-bracket-view>
        </div>
    </div>
</div>
